/**
 * External dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

export const megaphone = (
	<SVG width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
		<Path
			d="M20.2581 16.0436L25.3225 24.0032H36.1314C38.6025 24.0032 40.0003 22.6229 40.0003 20.162V11.9051C40.0003 9.44419 38.6003 8.06396 36.1292 8.06396H25.3203L20.2559 16.0436H20.2581Z"
			fill="var(--wpds-color-background-surface-neutral-weak, #F0F0F0)"
		/>
		<Path
			d="M25.0778 10.1431H3.86889C1.4 10.1431 0 11.5233 0 13.9864V18.2891C0 20.75 1.4 22.1013 3.87111 22.1013H25.08C27.5511 22.1013 28.9489 20.7211 28.9489 18.2602V15.3156C28.9489 12.8547 27.5489 10.1453 25.0778 10.1453V10.1431Z"
			fill="var(--wpds-color-background-surface-neutral-weak, #F0F0F0)"
		/>
		<Path
			d="M33.5778 0H29.9311C27.8044 3.89216 25.0889 10.1498 14 10.1498V22.1014C25.0867 22.1014 27.8044 28.3368 29.9311 32.229H33.5778C35.0533 32.229 35.8978 31.3947 35.8978 29.9057V2.32331C35.8978 0.83435 35.0556 0 33.5778 0Z"
			fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)"
		/>
		<Path
			d="M11.7958 18.6687H5.99805V40.0001H9.54471C9.56471 40.0001 9.57138 40.0001 9.57138 40.0001H9.7336C13.1447 40.0001 14.2292 37.841 13.8958 35.4045C13.6669 33.7314 12.7358 26.0869 11.7958 18.6665V18.6687Z"
			fill="var(--wpds-color-background-surface-neutral-weak, #F0F0F0)"
		/>
	</SVG>
);
